import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import { Router } from '@angular/router';
import { UserI, UserdataI } from './interface';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { LoadingController } from '@ionic/angular';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public user$: Observable<any> = this.afsAuth.user;


  constructor(private afsAuth: AngularFireAuth,
              private router: Router,
              private firestore: AngularFirestore,
              public loadingController: LoadingController,
              ) {

                this.afsAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
               }

  /*ME LOGEO*/
  async login(user: UserI) {
    const email = user.email.trim();
    const password = user.password.trim();
  
    try {
      const credential = await this.afsAuth.signInWithEmailAndPassword(email, password);
      return { success: true, user: credential.user };
    } catch (error: any) {
      return { success: false, error: this.traducirError(error.code) };
    }
  }
  
  // Traduce los códigos de error de Firebase a mensajes claros en español
  private traducirError(codigo: string): string {
    switch (codigo) {
      case 'auth/invalid-email':
        return 'El correo no es válido';
      case 'auth/user-disabled':
        return 'Esta cuenta ha sido deshabilitada';
      case 'auth/user-not-found':
        return 'No existe una cuenta con este correo';
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        return 'Correo o contraseña incorrectos';
      case 'auth/too-many-requests':
        return 'Demasiados intentos. Intenta más tarde';
      case 'auth/network-request-failed':
        return 'Sin conexión a internet';
      default:
        return 'Ocurrió un error al iniciar sesión';
    }
  }

/*ME DESLOGEO*/
async logoutUser() {
  const loading = await this.loadingController.create({
    spinner: 'crescent',
    message: 'Saliendo...',
    cssClass: 'class-cargando',
    backdropDismiss: false,
    duration: 8000,                // seguro: si algo se cuelga, se quita solo
  });
  await loading.present();

  try {
    await this.afsAuth.signOut();
    await this.router.navigate(['/login']);
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
  } finally {
    await loading.dismiss();       // siempre se quita, con o sin error
  }
}

  /*SABER SI EL USUARIO ESTA LOGEADO O NO*/
  status(){
    return this.afsAuth.user;
  }


  /*OBTENER EL ID DEL USER LOGEADO*/
  getUser(id): Observable<any> {
    return this.firestore.collection('users').doc(id).snapshotChanges();   
  }

}

function reject(err: any): any {
  throw new Error('Function not implemented.');
}

